__turbopack_context__.v({
  "darkNotification": "headerMobile-module-scss-module__Tzd2gq__darkNotification",
  "hasNotifications": "headerMobile-module-scss-module__Tzd2gq__hasNotifications",
  "headerMobile": "headerMobile-module-scss-module__Tzd2gq__headerMobile",
  "lightNotification": "headerMobile-module-scss-module__Tzd2gq__lightNotification",
  "scrolled": "headerMobile-module-scss-module__Tzd2gq__scrolled",
  "sidebarMenu": "headerMobile-module-scss-module__Tzd2gq__sidebarMenu",
  "visible": "headerMobile-module-scss-module__Tzd2gq__visible",
});
